export default "__VITE_ASSET__zMFR6Lye__"